import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL;

const BMPContext = createContext(null);

export function BMPProvider({ children, userInfo }) {
  const [profile, setProfile] = useState(null);
  const [profileLoading, setProfileLoading] = useState(true);
  const [bmpView, setBmpView] = useState('catalog');
  const [viewParams, setViewParams] = useState({});

  const isProducer = profile?.role === 'productor';
  const isBuyer = profile?.role === 'exportadora' || profile?.role === 'comercial';

  const bmpNavigate = useCallback((view, params = {}) => {
    setBmpView(view);
    setViewParams(params);
  }, []);

  const fetchProfile = useCallback(async () => {
    setProfileLoading(true);
    try {
      const res = await axios.get(`${API}/market/profile/me/`);
      setProfile(res.data);
    } catch (e) {
      if (e.response?.status === 404) setProfile(null);
    } finally {
      setProfileLoading(false);
    }
  }, []);

  const refreshProfile = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/market/profile/me/`);
      setProfile(res.data);
    } catch (e) {
      if (e.response?.status === 404) setProfile(null);
    }
  }, []);

  useEffect(() => { fetchProfile(); }, [fetchProfile]);

  const value = {
    profile,
    profileLoading,
    isProducer,
    isBuyer,
    bmpView,
    viewParams,
    bmpNavigate,
    refreshProfile,
    userInfo,
  };

  return <BMPContext.Provider value={value}>{children}</BMPContext.Provider>;
}

export function useBMP() {
  const ctx = useContext(BMPContext);
  if (!ctx) throw new Error('useBMP must be used within BMPProvider');
  return ctx;
}

export default BMPContext;
